"use strict";

exports.__esModule = true;
exports.default = void 0;

var _buttonGroup = _interopRequireDefault(require("./button-group"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BButtonGroup: _buttonGroup.default,
  BBtnGroup: _buttonGroup.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/button-group/index.js
// module id = ZhCs
// module chunks = 0